import { Component, DestroyRef, effect, ElementRef, inject, signal } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { observeResize } from '@models/utils/dom-ui';

import pkg from '@root/package.json';
import { BaseMin } from '@utils/base-min';

@Component({
    selector: 'vz-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    standalone: false,
    host: {
        '[class.fit]': 'true',
        '[class.layout]': 'true'
    }
})
export class AppComponent extends BaseMin {

    // newVersionReady: boolean = false;
    // newVersionHidden: boolean = false;
    version: string = pkg.version;

    private readonly _swu       = inject(SwUpdate);
    private readonly _destroy   = inject(DestroyRef);
    private readonly _el        = inject(ElementRef);

    constructor() {
        super();
        const bu = this._store.getItem('apiBaseUrl');
        if (!bu) {
            let schema = 'https://';
            let baseDomain = this.__ENV.baseDomain;
            if (origin.indexOf('://localhost') == -1) {
                schema = origin.substring(0, origin.indexOf('://') + 3);
                baseDomain = this.enterprise
                    ? origin.substring(origin.indexOf('://') + 3)
                    : origin.substring(origin.indexOf('://wiki.') + 8);
            }
            this._store.setItem('apiBaseUrl', `${schema}api.${baseDomain}`);
            this._store.setItem('appBaseUrl', `${schema}wiki.${baseDomain}`);
        }
        document.getElementById('appLoaderContainer')?.remove();
        if (this._swu.isEnabled) {
            this._swu.versionUpdates.subscribe(e => {
                if (e.type == 'VERSION_READY') {
                    window.location.reload();
                }
            });
        }
        // this._store.crashReport.subscribe(crash => {
        //     if (!this.crash) {
        //         this.crash = crash;
        //         this.reportSent = undefined;
        //     }
        // });
        effect(() => console.log('-[AppComponent]---> constructor, _mobile:', this._mobile()));
        observeResize(this._destroy, this._el.nativeElement, 500).subscribe(() => {
            const r = this._el?.nativeElement.getBoundingClientRect();
            this._mobile.set(r?.width && r.width < 1024);
            this._Changed();
        });
    }

    reload(): void {
        console.warn('[AppComponent] reload');
        window.location.reload();
    }

}
